var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteGenRx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.38617 2.9165L5.94624 1.23631C6.05967 0.896029 6.37811 0.666504 6.73681 0.666504H11.2368C11.5955 0.666504 11.9139 0.896029 12.0274 1.23631L12.5874 2.9165H16.4868C16.947 2.9165 17.3201 3.2896 17.3201 3.74984C17.3201 4.21007 16.947 4.58317 16.4868 4.58317H15.7726L15.161 14.98C15.0833 16.3014 13.989 17.3332 12.6653 17.3332H5.30831C3.98462 17.3332 2.89036 16.3014 2.81263 14.98L2.20105 4.58317H1.50008C1.03984 4.58317 0.666748 4.21007 0.666748 3.74984C0.666748 3.2896 1.03984 2.9165 1.50008 2.9165H5.38617ZM7.14299 2.9165H10.8306L10.6362 2.33317H7.33744L7.14299 2.9165ZM14.103 4.58317H3.8706L4.47642 14.8821C4.50233 15.3226 4.86708 15.6665 5.30831 15.6665H12.6653C13.1065 15.6665 13.4713 15.3226 13.4972 14.8821L14.103 4.58317ZM10.4051 6.69786C10.4338 6.23851 10.8294 5.88942 11.2888 5.91813C11.7481 5.94684 12.0972 6.34248 12.0685 6.80182L11.6935 12.8018C11.6648 13.2612 11.2692 13.6103 10.8098 13.5815C10.3505 13.5528 10.0014 13.1572 10.0301 12.6979L10.4051 6.69786ZM7.94352 12.6979C7.97223 13.1572 7.62313 13.5528 7.16379 13.5815C6.70445 13.6103 6.3088 13.2612 6.2801 12.8018L5.9051 6.80182C5.87639 6.34248 6.22548 5.94684 6.68482 5.91813C7.14417 5.88942 7.53981 6.23851 7.56852 6.69786L7.94352 12.6979Z",
    fill: "#FC5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteGenRx);
export default __webpack_public_path__ + "static/media/delete-gen-rx.53f3caab5fa5afa346c538497772ded3.svg";
export { ForwardRef as ReactComponent };